import { ORDER, SORT } from "~/constants";
import useRequest from "~/hooks/use-request";
import { formatIdentity, formatPaginatedResponseItems, formatRequestOptions } from "../format";
import SubCategoriesAPI from "./sub";

const CategoriesAPI = {
  subCategories: SubCategoriesAPI,

  load(options?: IRequestPaginatedOptions): Promise<IPaginatedResponse<IModelIdentity>> {
    const { request } = useRequest();
    const generalParams = formatRequestOptions(options);
    const params = { ...generalParams, filters: { media_type: "identity", archived: options?.archived } };

    return request
      .post<IPaginatedResponse<IResponseIdentity>>("/api/identity/list", { body: params })
      .then(response => formatPaginatedResponseItems(response, formatIdentity));
  },

  loadById(id: string): Promise<IModelIdentity> {
    const { request } = useRequest();

    return request
      .get<IContentResponse<IResponseIdentity>>(`/api/identity/get_by_id/id/${id}`)
      .then(async (response) => {
        return formatIdentity(response.content);
      });
  },

  async loadWithSubcategories() {
    const { content: { entries: categories } } = await CategoriesAPI.load({ page: 0, pageSize: 100, order: ORDER.asc, sort: SORT.order });
    const { content: { entries: subcategories } } = await SubCategoriesAPI.loadAllSubCategory();

    return categories.map((category) => {
      return {
        ...category,
        subCategories: subcategories.filter(subcategory => subcategory.mainCategories.includes(category.id)),
      };
    });
  },
};

export default CategoriesAPI;
